const KEY_PREFIX = "meteotracker.map.startView."

export function loadStartView(user) {
  if (!user) return null
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY_PREFIX + user) ?? "null")
    const [lat, lng] = parsed?.center ?? []
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
    return { center: [lat, lng], zoom: Number.isFinite(parsed.zoom) ? parsed.zoom : null }
  } catch {
    return null
  }
}

export function saveStartView(user, view) {
  if (!user) return
  try {
    localStorage.setItem(KEY_PREFIX + user, JSON.stringify(view))
  } catch {
    // Private Mode / gesperrter Storage: Start springt dann wie ohne gemerkte Ansicht
  }
}
